import { useRouteMatch } from "react-router-dom";
import { appConfig } from "../../appConfig";
import { concatUrlPathnames } from "../sport-utils";
import { getConfiguration } from '../utils/configuration';
import { getEncodedURI } from '../utils/getEncodedURI';
import { systemCode, xs_languageCode } from "../..";
import { isSeoUrlDisabled } from "./seoUtils";
import { isLoadedInIframe } from "../utils/isLoadedInIframe";

export function useAbsolutePath(urlPath,parents,urlPathSeo,useRelative=false){
    const conf = getConfiguration();
    let toReturn = '';

    let basename = appConfig.BASENAME;
    const forcePrematchUrl =  ['/xcomponents/in-evidenza'];

    if(isLoadedInIframe()) {
        if(conf?.seo) {
            if(window.xsportSeoCtxs?.[xs_languageCode] != undefined) {
                basename = window.xsportSeoCtxs?.[xs_languageCode];
            }
        }
    }

    try {
        const routeMatch = useRouteMatch();
        let routeUrl = routeMatch?routeMatch.url:"";
        /*if(routeUrl === '/')
            routeUrl = '';*/
        if(appConfig.ROUTES.routeFromPath (routeUrl) === 'prematch' || forcePrematchUrl.includes(routeUrl)  ){
            routeUrl = appConfig.ROUTES.prematch['prematch'] || appConfig.ROUTES.prematch['top-match'];
        }
        
        let p;
        let m;

        if(conf.seo && !isSeoUrlDisabled(systemCode) && (urlPathSeo || null) != null){
            urlPathSeo = getEncodedURI(urlPathSeo);
            if(urlPathSeo.startsWith('/')){
                if(useRelative){
                    toReturn = basename === '/'? urlPathSeo: urlPathSeo.replace(basename,'')
                }else{
                    toReturn = urlPathSeo;
                }
            }else{
                toReturn = concatUrlPathnames(useRelative?'':basename,routeUrl, urlPathSeo);
            }
        }else{
            p = routeUrl==urlPath?routeUrl:concatUrlPathnames(routeUrl, urlPath);
            if(appConfig.URL_PATH_MAPPINGS){
                m = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==p});
            }
            if(window.seoConfig && window.seoConfig.ump && parents){
                parents.forEach(function(parent){
                    let s = concatUrlPathnames(routeMatch?routeMatch.url:"", parent['path'],parent['suffix']);
                    //let ms = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==s});
                    let ms = Object.keys(window.seoConfig.ump).find(function(k){return window.seoConfig.ump[k]==s});
                    if(ms){
                        p = p.replace(concatUrlPathnames(routeUrl,parent['path']),ms);
                    }
                })
            }/*else{
                if(appConfig.URL_PATH_MAPPINGS){
                    m = Object.keys(appConfig.URL_PATH_MAPPINGS).find(function(k){return appConfig.URL_PATH_MAPPINGS[k]==p});
                }
            }*/
            toReturn = concatUrlPathnames(useRelative?'':basename, (m||p));
        }
    }catch(err) {
        console.log(err);
        toReturn = '';
    }

    
    
    
    return toReturn;
}